import React from 'react';

import SpecificationDetails from './SpecificationDetails';
import { isDefined, isObject } from '../../../utils/isDefined';
import formatDate from '../../../utils/formatDate';
import styles from '../styles/specification';
import { withStyles } from '@material-ui/styles';
import { translate } from '../../../i18n/I18nProvider';

const Specifications = ({ classes, order, accountName, client }) => {
  if (!isObject(order)) {
    return '';
  }

  const { order_id, created_at, created_by, updated_at } = order;

  let createdBy = created_by;

  return (
    <div>
      <div className={classes.rowContainer}>
        <div>Order ID</div>
        <div className={classes.value}>{order_id}</div>
      </div>
      <div className={classes.rowContainer}>
        <div>{translate('CREATED_AT')}</div>
        <div className={classes.value}>{formatDate(created_at)}</div>
      </div>
      <div className={classes.rowContainer}>
        <div>{translate('UPDATED_AT')}</div>
        <div className={classes.value}>{formatDate(updated_at)}</div>
      </div>
      {isObject(createdBy) && (
        <div>
          {translate('CREATED_BY')}
          <div className={classes.innerRowContainer}>
            <div>{translate('NAME')}</div>
            <div className={classes.value}>{createdBy.name}</div>
          </div>
          <div className={classes.innerRowContainer}>
            <div>{translate('TABLE.USERNAME')}</div>
            <div className={classes.value}>{createdBy.username}</div>
          </div>
          <div className={classes.innerRowContainer}>
            <div>email</div>
            <div className={classes.value}>{createdBy.email}</div>
          </div>
        </div>
      )}

      {isDefined(order?.specification) && (
        <>
          {translate('SPECIFICATION')}
          <SpecificationDetails
            data={order?.specification}
            accountName={accountName}
            classes={classes}
            client={client}
          />
        </>
      )}
    </div>
  );
};

export default withStyles(styles)(Specifications);
